export default "__VITE_ASSET__DYLdhpCC__"